export const reactQueryKeys = {
  userInfo: 'userInfo',
  extension: 'extension',
  asteriskUrl: 'asteriskUrl',
  branchFeatures: 'branchFeatures',
  pauseStatus: 'pauseStatus',
  pauseReasons: 'pauseReasons',
  history: 'history',
  leadPhoneBook: 'leadPhoneBook',
  permissions: 'permissions',
  desktopAudioDevices: 'desktopAudioDevices',
  codWeb: 'codWeb',
};
